import { render, staticRenderFns } from "./PmReportGnbDataRightList.vue?vue&type=template&id=5390215e&"
import script from "./PmReportGnbDataRightList.vue?vue&type=script&lang=js&"
export * from "./PmReportGnbDataRightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports